import { Component, Input } from '@angular/core';

import { IgoMap } from '../shared/map';

@Component({
  selector: 'igo-zoom-button',
  template: require('./zoom-button.component.html'),
  styles: [require('./zoom-button.component.styl')]
})
export class ZoomButtonComponent {

  @Input()
  get map(): IgoMap { return this._map; }
  set map(value: IgoMap) {
    this._map = value;
  }
  private _map: IgoMap;

  @Input()
  get color(): string { return this._color; }
  set color(value: string) {
    this._color = value;
  }
  private _color: string;

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/map/zoom-button/zoom-button.component.ts